<template>
  <v-col cols="12" md="5" lg="4">
    <slot></slot>
  </v-col>
</template>

<script>
export default {}
</script>
